import { render, staticRenderFns } from "./PrioritySettingPanel.vue?vue&type=template&id=1dd6fab0&scoped=true"
import script from "./PrioritySettingPanel.vue?vue&type=script&lang=js"
export * from "./PrioritySettingPanel.vue?vue&type=script&lang=js"
import style0 from "./PrioritySettingPanel.vue?vue&type=style&index=0&id=1dd6fab0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd6fab0",
  null
  
)

export default component.exports